import axios from "axios";
import { API_URL } from "@/config";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/recipients`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, recipientId) {
      const response = await axios.get(`${API_URL}/recipients/${recipientId}`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, recipientData) {
      const response = await axios.post(`${API_URL}/recipients`, recipientData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async update(_, { recipientId, recipientData }) {
      const response = await axios.put(`${API_URL}/recipients/${recipientId}`, recipientData);

      if (response.status !== 200 || !response.data) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async delete(_, recipientId) {
      const response = await axios.delete(`${API_URL}/recipients/${recipientId}`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return true;
    },
  },
};
